import { debriefV2EnTranslations } from './debriefV2.en';
import { debriefV2HeTranslations } from './debriefV2.he';

export const debriefV2Translations = {
  en: debriefV2EnTranslations,
  he: debriefV2HeTranslations,
} as const;
